import axios from 'axios'
import {rootUrl} from '@/common/js/config'
import util from '@/common/js/util'
import {logout} from "@/api/login-api";
import store from "@/store/index";
import {httpGet,httpPost} from "@/common/js/util";

function getInfo (url, parames) {
  /*
  return Promise.resolve([{"title": "菜单一", "url": "http://www.baidu.com"}, {
     "title": "菜单二",
     "url": "http://ledc.changyan.cn"
   }])
   */
  /*
  return Promise.resolve({
        code: 1,
        message: 'success',
        data: {
          webServerUrl: 'http://localhost:8081'
        }
      })
  */
  //请求失败重复请求次数
  let retryTimes = 3;
  const  params = {
    initUrl: parames.initUrl,
    headers: {'X-Requested-With': 'XMLHttpRequest'}
  }
  return httpPost(url,params,retryTimes);
}

// 判断是否已经登录及是否有权限
export function loggedIn () {

  const url = rootUrl.checkAuth;
  var initUrl = window.location.href;
  return new Promise(resolve => {
    getInfo(url, {initUrl: initUrl}).then(res => {
      store.commit('baseUrl', res.data.basePath);
		  store.commit('appName', res.data.appName);
		  store.commit('appSecret', res.data.appSecret);
		  store.commit('cystorageUrl', res.data.cystorageUrl);
      if (res.code === '1') {
        util.localstorage.set("user", res.data);
        store.commit('judgeUserStatusChange', {
          flag: true
        });
        resolve('isOk')
      }else if (res.code === '-1'){
        resolve('noLogin')
      }else if (res.code === '-2') {
        resolve('quitSystem')
      }else{
        util.localstorage.set("user", res.data);
        store.commit('judgeUserStatusChange', {
          flag: true
        });
        //用户状态禁用，需强制退出
        if(res.data.status ==4){
          resolve('forbidden')
        }else {
          resolve('noAuth')

        }
      }
    })
    // .catch(error => {
    //   console.log(JSON.stringify(error))
    //   let {sessionstatus, authoritystatus} = error.response.headers
    //   if (sessionstatus === 'no') {
    //     resolve('noLogin')
    //   } else {
    //     if (authoritystatus === 'no') {
    //       resolve('noAuth')
    //       return
    //     }
    //     resolve('pass')
    //   }
    // })
  })
}

export function beLogout() {
  return new Promise(resolve => {
    logout().then(res => {
      util.localstorage.clear();
      store.commit('changeRefreshHeader', {
        headerRefresh: true
      });
      resolve('logout')
    }).catch(error => {
      resolve('logoutError')
    })
  })
}

/*
function hasPermission(store, path) {
  const url = rootUrl.checkAuth
  return new Promise(resolve => {
    getInfo(url).then(res => {
      if (res.code === ERR_OK) {
        let authorityStatus = res.headers.authoritystatus
        if (authorityStatus === 'no') {
          resolve(false)
        } else {
          resolve(true)
        }
      }
    })
      .catch(error => {
        resolve(false)
      })
  })
}
*/

// 权限分两种，
// 一种是本地存储的权限，这意味着服务端修改权限后，需要前端退出重新登录
// 一种是实时从服务端判单是否有权限，不需要重新登录，但需要发送请求
/*
export async function hasPermission(store, path) {
  let permissions = store.getters.permissions || await getPermission(store)
  let hasPer = false
  permissions.forEach((index, permission) => {
    if (permission == path) {
      hasPer = true
      return
    }
  })
  return hasPer
}
*/



// WEBPACK FOOTER //
// ./src/api/auth.js